import ExtraPricingUnit from "@/model/ExtraPricingUnit";

const EXTRA_PRICING_UNITS: ExtraPricingUnit[] = [
  "PER_STAY",
  "PER_NIGHT",
  "PER_GUEST",
  "PER_GUEST_PER_NIGHT",
];

export default EXTRA_PRICING_UNITS;
